export const variables = {
  EMPTY_DATA_TEXT: 'Chưa có dữ liệu'
}

export const PAGINATION = {
  PAGE: 1,
  PAGE_SIZE_SMALL: 5,
  PAGE_SIZE: 10,
  SIZEMAX: 1000,
  PAGE_SIZE_OPTIONS: ['10', '20', '50', '100'],
  SHOW_SIZE_CHANGER: true,
  PER_PAGE_TEXT: '/ trang',
  SORT: 'lastModifiedDate,desc'
}

export const TYPE_BUTTON_FOOTER = {
  EDIT: 'EDIT',
  ADD: 'ADD'
}
